import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AnimalSelectionAnimalDialogComponent } from './animal-selection-animal-dialog.component';
import { IonicModule } from '@ionic/angular';
import { TranslocoModule } from '@ngneat/transloco';
import { TranslocoLocaleModule } from '@ngneat/transloco-locale';
import { DialogLayoutModule } from '@tcc-mono/shared/ui/dialog-layout';
import { StackedListModule } from '@tcc-mono/shared/ui/stacked-list';

@NgModule({
  imports: [
    CommonModule,
    IonicModule,
    DialogLayoutModule,
    TranslocoModule,
    StackedListModule,
    TranslocoLocaleModule
  ],
  declarations: [AnimalSelectionAnimalDialogComponent],
  exports: [AnimalSelectionAnimalDialogComponent]
})
export class AnimalSelectionAnimalDialogModule {}
